import { setAuthDetails, setCustomerDetails } from "../../reducers/customerDetails"
import store from "../../store"

export const SetCustomerDetailsAction = (data: any) => {
    store.dispatch(setCustomerDetails(data))
}
export const SetAuthDetailsAction = (data: any) => {
    store.dispatch(setAuthDetails(data))
}
